import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/saas.png'


const _hoisted_1 = {
  class: "rounded-3 p-25 manage-app-for-dark",
  style: {"background-color":"#b2ff97"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"mx-auto py-sm-4 my-1\" style=\"max-width:210px;\"><h2 class=\"fs-24 text-secondary mb-20\"> Manage Your Dashboard From Your Mobile </h2><a href=\"#\" class=\"app-btn\"> Download App </a><div class=\"text-center\"><img src=\"" + _imports_0 + "\" alt=\"saas\"></div></div>", 1)
  ]))]))
}